/**
 * * @module component/subnavigation.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";

const Subnavigation = Backbone.View.extend({
  el: $(document),

  events: {
    "click .subnav-title-expand-button": "expandMobileSubnav"
  },

  initialize: function () {
    this.render();
  },

  collapseSubnav: function() {
    const $subnavTitle = $(".page-navigation-title");

    if (!$subnavTitle){
      return;
    }

    $subnavTitle.append(
      '<button class="subnav-title-expand-button icon icon-arrow-up"></button>'
    );

    $(".subnav-title-expand-button")
      .attr("data-toggle", "collapse")
      .addClass("collapsed")
      .attr("data-target", "#page-navigation-list")
      .attr("aria-controls", "page-navigation-list")
      .attr("aria-expanded", false);

    $(".page-navigation ul").addClass("collapse");
    
  },

  expandMobileSubnav: function (e) {
    e.preventDefault();
    $(".page-navigation ul").slideDown();
  },

  generateRandomNumber: function (max) {
    return Math.floor(Math.random() * Math.floor(max));
  },

  // page_navigation: function () {
  //   var _this = this;
  //   var $itemWithChildren = $(".page_item_has_children");

  //   if ($itemWithChildren) {
  //     $itemWithChildren.each(function () {
  //       var $i = _this.generateRandomNumber(100);
  //       var $item = $(this);

  //       $item.append('<button class="icon icon-plus-in-circle"></button>');

  //       var $button = $(".icon-plus-in-circle", $item);

  //       $button
  //         .attr("data-toggle", "collapse")
  //         .attr("data-target", "#child-menu-" + $i)
  //         .attr("aria-controls", "collapsedSidebar")
  //         .attr("aria-expanded", false);

  //       var $children = $(".children", $item);
  //       $children.attr("id", "child-menu-" + $i);
  //       $children.addClass("collapse");

  //       $(".children").on("show.bs.collapse", function (e) {
  //         $(e.target).next("button").addClass("open");
  //       });

  //       $(".children").on("hide.bs.collapse", function (e) {
  //         $(e.target).next("button").removeClass("open");
  //       });
  //     });
  //   }
  // },

  render: function () {
    this.collapseSubnav();
    // this.page_navigation();
  },
});

export default Subnavigation;
